export class ILoginReq {
  user: string;
  password: string;

  constructor( user: string, pass: string) {
    this.user = user;
    this.password = pass;
  }
}
